export default __webpack_public_path__ + "static/media/fuelEnDetailMobile.9f27b274.jpg";